import React from 'react';
import { useQuery, Loading, Error } from 'react-admin';

const SpeDue = (record) =>{

    const { data, loading, error } = useQuery({ 
        type: 'getOne',
        resource: '/spedue',
        payload: { id: (record && record.ssn) ? record.ssn: null}
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    //console.log(data)
    return (data)
}

export default SpeDue